import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './Button.module.css';

const Button = ({
  primary = false,
  children,
  onClick,
  signupForm = false,
  disabled = false,
  type = 'submit',
}) => {
  return (
    <button
      className={`${classes.button} ${
        primary ? classes.primary : signupForm ? classes.signupForm : ''
      }`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  primary: PropTypes.bool,
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  signupForm: PropTypes.bool,
};

export default Button;
